export default function ENFK(props) {
  return (
    <div className="row">
      <div className="col-12 p-5">
        <article className="main description">
          <h1>شخصیت “قهرمان”</h1>{" "}
          <blockquote>
            <p>
              هر کاری که هم اکنون انجام می&zwnj;دهید همچون موج به بیرون گسترش
              می&zwnj;یابد و همه را تحت تأثیر قرار می&zwnj;دهد. وضعیت شما
              می&zwnj;توانید موجب درخشش قلبتان شود یا اضطراب را منتقل نماید. نفس
              شما می&zwnj;توانید عشق بتاباند یا اتاق را در افسردگی فرو ببرد.
              نگاهتان می&zwnj;تواند شادی را بیدار کند. کلماتتان می&zwnj;تواند
              الهام&zwnj;بخش آزادی باشد. تک&zwnj;تک اعمال شما می&zwnj;تواند
              قلب&zwnj;ها و ذهن&zwnj;ها را باز کند.
            </p>{" "}
            <footer>David Deida</footer>
          </blockquote>{" "}
          <p>
            قهرمانان رهبرانی بالفطره و سرشار از عشق و شور و جذبه هستند. این
            شخصیت&zwnj;ها که حدود دو درصد از جمعیت را تشکیل می&zwnj;دهند اغلب
            سیاستمداران، مربیان و معلمان ما هستند که الهام&zwnj;بخشیدن دیگران
            برای برای موفقیت و انجام کارهای خوب در جهان هستند. قهرمانان
            به&zwnj;طور طبیعی دارای اعتماد به نفس هستند که موجب پدید آمدن نفوذ
            می&zwnj;شود، از هدایت کردن دیگران برای همکاری با یکدیگر و بهبود
            بخشیدن خود و جامعه&zwnj;شان دچار غرور و شادی می&zwnj;شوند.
          </p>{" "}
          <h2>اعتقاد راسخ به مردم</h2>{" "}
          <p>
            مردم جذب شخصیت&zwnj;های قوی می&zwnj;شوند، و قهرمانان اصالت، دغدغه و
            نوع&zwnj;دوستی از خود ساطع می&zwnj;کنند و از به پا خاستن و صحبت کردن
            در هنگامی که احساس می&zwnj;کنند چیزی باید گفت نمی&zwnj;ترسند. آنها
            به&zwnj;راحتی می&zwnj;توانند با دیگران ارتباط برقرار کنند،
            به&zwnj;خصوص به صورت حضوری و ماهیت روشنگرانه افراد دارای گونه شخصیتی
            قهرمان به آنها کمک می&zwnj;کند تا به ذهن همه دسترسی پیدا کنند، چه از
            طریق حقایق و منطق یا احساسات خام. قهرمانان به&zwnj;راحتی
            انگیزه&zwnj;های افراد و رویدادهای به ظاهر مجزا را مشاهده
            می&zwnj;کنند و قادر هستند این ایده&zwnj;ها را در کنار هم قرار دهند و
            ارتباط آنها را به&zwnj;عنوان هدفی مشترک با فصاحت و نوعی مسحورکنندگی
            بیان کنند.
          </p>{" "}
          <p>
            علاقه قهرمانان به دیگران واقعی و تقریباً نوعی نقص است - وقتی افرادی
            با این گونه شخصیتی به کسی باور داشته باشند، ممکن است بیش از حد در
            مشکلات آن شخص درگیر شوند یا بیش از حد به وی اعتماد کنند. خوشبختانه،
            این اعتماد معمولاً نوعی رسالت درونی است، زیرا نوع&zwnj;دوستی و اصالت
            قهرمانان الهام&zwnj;بخش کسانی است که به بهتر شدن خود اهمیت
            می&zwnj;دهند. اما اگر این شخصیت&zwnj;ها مراقب نباشند، ممکن است
            خوش&zwnj;بینی خود را بیش از حد توانشان تعمیم دهند و گاهی اوقات
            دیگران را وادار به حرکت کنند حال آنکه ممکن است این افراد آمادگی تا
            تمایلی به این کار نداشته باشند.
          </p>{" "}
          <p>
            قهرمانان نسبت به دام دیگری نیز آسیب&zwnj;پذیر هستند: آن&zwnj;ها
            ظرفیت فوق&zwnj;العاده&zwnj;ای برای تأمل و تجزیه و تحلیل احساسات خود
            دارند، اما اگر بیش از حد در وضعیت فرد دیگری گرفتار شوند، ممکن است
            دچار نوعی مالیخولیای عاطفی شوند، مشکلات افراد دیگر را در خود ببینند،
            و بکوشند اشکالی را برطرف کنند که واقعاً وجود ندارد. اگر این
            شخصیت&zwnj;ها به نقطه&zwnj;ای برسند که محدودیت&zwnj;های شخص دیگری
            آنها را متوقف سازد، ممکن است توانایی آنها برای مشاهده گذشته معضل از
            دست برود و در نتیجه هیچ کمکی نکنند. وقتی چنین اتفاقی رخ داد، مهم است
            که قهرمانان خود را عقب بکشند و با تأمل در خود بین آنچه واقعاً احساس
            می&zwnj;کنند و آنچه که مسئله&zwnj;ای جداگانه است و باید از منظری
            دیگری به آن نگریست تمایز قائل شوند.
          </p>{" "}
          <h2>
            ... کشمکش نباید ما را از حمایت از حرکتی که به باورمان عادلانه است
            باز بدارد
          </h2>{" "}
          <blockquote className="no-footer">
            <p>
              قهرمانان افرادی اصیل و اهل توجه هستند که وقت حرف زدن حرف
              می&zwnj;زنند و وقت عمل کردن عمل می&zwnj;کنند، و هیچ چیزی به اندازه
              پذیرفتن مسئولیت، متحد کردن و انگیزه&zwnj;بخشی به تیم خود با
              اشتیاقی سرایت&zwnj;کننده آنها را خوشحال نمی&zwnj;کند.
            </p>
          </blockquote>{" "}
          <p>
            افراد دارای گونه شخصیتی قهرمان نوع&zwnj;دوستانی پرشور هستند، گاهی
            اوقات حتی تا مرز نقض، و بعید است وقتی در تأیید مردم و ایده&zwnj;های
            آنها به پا می&zwnj;خیزند از سلاح به دست گرفتن هراس داشته باشند. جای
            تعجب نیست که بسیاری از قهرمانان معروف رهبران سیاسی و فرهنگی بانفوذی
            هستند - این گونه شخصیتی می&zwnj;خواهد راه آینده&zwnj;ای روشن&zwnj;تر
            را نشان دهد، چه با هدایت یک ملت به سمت رفاه، یا رهبری تیم لیگ
            سافت&zwnj;بال برای پیروز شدن در مبارزه&zwnj;ای دشوار.
          </p>
        </article>
      </div>
    </div>
  );
}
